import { z } from 'zod';

import { CompanyId, LosId, TaskId, TeamId, UserId } from '../BrandedIds';
import { TaskType } from '../tasks/Task';
import { TaskStatus } from '../tasks/TaskStatus';
import { zodTemporalInstant, zodTemporalPlainDate } from '../Temporal';

export const ExportableTask = z
  .object({
    id: TaskId,
    companyId: CompanyId,
    loanId: LosId.optional(),

    type: TaskType,
    status: TaskStatus,

    title: z.string().optional(),
    details: z.string(),

    dueDate: zodTemporalPlainDate.optional(),
    completedAt: zodTemporalInstant.optional(),

    assignees: z.array(UserId).optional(),
    teamAssignees: z.array(TeamId).optional(),

    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,
  })
  .meta({ title: 'Task' });

export type ExportableTask = z.infer<typeof ExportableTask>;
